import styled from "styled-components";
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";

export const AdvancedGamesFilterHeaderDefaultBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    padding: 6px;
`;

const AdvancedGamesFilterHeaderMrGreenBox = styled(AdvancedGamesFilterHeaderDefaultBox)`
    color: ${({theme}) => theme.colors.textContrast };
    padding: 0 0 1rem 0;
`;

const AdvancedGamesFilterHeaderSIBox = styled(AdvancedGamesFilterHeaderDefaultBox)`
    padding-left: 15px;
    padding-right: 15px;
    
    svg {
        color: white;
        width: 2rem;
        height: 2rem;
    }
`;

export const AdvancedGamesFilterHeaderBox = styledByTheme(AdvancedGamesFilterHeaderDefaultBox)
    .forSI(AdvancedGamesFilterHeaderSIBox)
    .forSICis(AdvancedGamesFilterHeaderSIBox)
    .forMrGreen(AdvancedGamesFilterHeaderMrGreenBox)
    .forMrGreenCis(AdvancedGamesFilterHeaderMrGreenBox).apply();